// Component-local messages: recovery is available in both languages, independently
// of the language restriction on creating new Portal payments.
export const portalRecoveryMessages = {
  en: {
    recovery: {
      title: 'Existing SBP flow payments',
      invoice: 'Invoice {id}',
      amounts: 'Invoice: {usdt} USDT',
      estimate: 'Original estimate: {amount} GNK. The exchange uses the rate at execution; this amount is not guaranteed.',
      actual: 'Actual exchange output: {amount} GNK. This is not your remaining wallet balance.',
      purchased: 'Purchased',
      price: ' · Price for this attempt: {amount} GNK',
      partialNotice: 'Only part of the selected flows was purchased, in ascending flow order. The remaining flows will not be bought automatically after a top-up. Buying them requires a new purchase you initiate.',
      zeroActual: 'Your exchange allocation: {amount} GNK',
      zeroNotice: 'The exchange is finished. No GNK were allocated to this invoice, so no GNK were credited and no flows were purchased. This is a final result, not a pending payment.',
      exchangeNotice: 'The GNK were credited to your wallet and were not spent on this basket. Adding funds will not restart this purchase. To buy flows, place a new purchase yourself after any needed top-up.',
      exchangeReason: {
        zero: 'The completed exchange produced a zero GNK allocation for this invoice.',
        insufficient: 'The available GNK were insufficient for the full basket at the current price.',
        unavailable: 'The full basket could not be purchased under the current conditions.',
        other: 'The exchange is complete, but the basket was not purchased.',
      },
      rub: 'Invoice payment: {amount} RUB',
      flow: 'Flow {type}',
      refresh: 'Check this invoice',
      reload: 'Reload invoices',
      more: 'Show more invoices',
      loading: 'Checking invoices…',
      open: 'Open the SBP payment page (new tab)',
      fallback: 'If the payment page does not open, use this same invoice link again. Do not create a replacement payment.',
      error: 'Unable to verify the payment status. Check this invoice again; do not pay again.',
      unavailable: 'A verified payment link is not available. Check this invoice again or contact support with its reference.',
      status: {
        preparing: 'Preparing payment',
        kyc_required: 'Identity verification required',
        awaiting_payment: 'Awaiting payment',
        processing: 'Payment is being processed',
        payment_confirmed: 'Payment confirmed; check activation for each flow below',
        awaiting_liquidity: 'Payment confirmed; awaiting conversion funds',
        converting: 'Payment confirmed; conversion in progress',
        exchanged: 'Exchange completed; basket not purchased',
        partially_purchased: 'Some selected flows were purchased; the full selection is not complete',
        prepaid: 'Flows prepaid; activation is not yet confirmed',
        activating: 'All selected flows purchased; activation is not yet complete',
        activated: 'All flows in this invoice are activated',
        failed: 'Payment failed; check this invoice before retrying payment',
        manual_review: 'Requires review; check each flow below. Do not pay again',
        unconfirmed: 'Full activation is not confirmed; check each flow below',
      },
      flowStatus: {
        prepaid: 'Prepaid, not activated',
        activating: 'Activation in progress',
        activated: 'Activated',
        manual_review: 'Requires review',
        unknown: 'Activation not confirmed',
        not_purchased: 'Not purchased with this invoice',
        insufficient: 'Not purchased: insufficient GNK',
        not_attempted: 'Purchase not attempted',
      },
    },
  },
  ru: {
    recovery: {
      title: 'Счета СБП за потоки',
      invoice: 'Счёт {id}',
      amounts: 'Счёт: {usdt} USDT',
      estimate: 'Первоначальная оценка: {amount} GNK. Обмен выполняется по курсу на момент исполнения; эта сумма не гарантирована.',
      actual: 'Фактический результат обмена: {amount} GNK. Это не остаток вашего кошелька.',
      purchased: 'Куплен',
      price: ' · Цена в этой попытке: {amount} GNK',
      partialNotice: 'Куплена только часть выбранных потоков по возрастанию их номеров. Остальные не будут куплены автоматически после пополнения. Для них нужно самостоятельно оформить новую покупку.',
      zeroActual: 'Ваша доля по обмену: {amount} GNK',
      zeroNotice: 'Обмен завершён. На этот счёт не выделено GNK: зачисления GNK и покупки потоков не было. Это окончательный результат, а не ожидание платежа.',
      exchangeNotice: 'GNK зачислены в ваш кошелёк и не потрачены на эту корзину. Пополнение не возобновит эту покупку. Чтобы купить потоки, оформите новую покупку самостоятельно, при необходимости предварительно пополнив кошелёк.',
      exchangeReason: {
        zero: 'По завершённому обмену на этот счёт выделена нулевая доля GNK.',
        insufficient: 'Доступных GNK не хватило на всю корзину по текущей цене.',
        unavailable: 'Всю корзину не удалось купить по текущим условиям.',
        other: 'Обмен завершён, но корзина не куплена.',
      },
      rub: 'Оплата по счёту: {amount} RUB',
      flow: 'Поток {type}',
      refresh: 'Проверить этот счёт',
      reload: 'Обновить список счетов',
      more: 'Показать ещё счета',
      loading: 'Проверяем счета…',
      open: 'Открыть страницу оплаты СБП (новая вкладка)',
      fallback: 'Если страница оплаты не открылась, повторно используйте эту же ссылку на счёт. Не создавайте новый платёж взамен.',
      error: 'Не удалось проверить статус платежа. Проверьте этот же счёт ещё раз; не оплачивайте повторно.',
      unavailable: 'Проверенная ссылка на оплату недоступна. Проверьте этот же счёт ещё раз или передайте его номер поддержке.',
      status: {
        preparing: 'Подготовка платежа',
        kyc_required: 'Нужно подтвердить личность',
        awaiting_payment: 'Ожидает оплаты',
        processing: 'Платёж обрабатывается',
        payment_confirmed: 'Оплата подтверждена; статус активации каждого потока указан ниже',
        awaiting_liquidity: 'Оплата подтверждена; ожидаются средства для конвертации',
        converting: 'Оплата подтверждена; идёт конвертация',
        exchanged: 'Обмен завершён; корзина не куплена',
        partially_purchased: 'Куплена только часть выбранных потоков',
        prepaid: 'Потоки предоплачены; активация ещё не подтверждена',
        activating: 'Все выбранные потоки куплены; активация ещё не завершена',
        activated: 'Все потоки по этому счёту активированы',
        failed: 'Платёж не прошёл; проверьте этот счёт перед повторной оплатой',
        manual_review: 'Нужна проверка; статус каждого потока указан ниже. Не оплачивайте повторно',
        unconfirmed: 'Полная активация не подтверждена; проверьте статус каждого потока ниже',
      },
      flowStatus: {
        prepaid: 'Предоплачен, не активирован',
        activating: 'Идёт активация',
        activated: 'Активирован',
        manual_review: 'Нужна проверка',
        unknown: 'Активация не подтверждена',
        not_purchased: 'Не куплен по этому счёту',
        insufficient: 'Не куплен: недостаточно GNK',
        not_attempted: 'Покупка не выполнялась',
      },
    },
  },
}
